const __request = require(`@/lib/data-service/default/__request/__request_contentType_json`);

export default function web_managerSupplier_flightSupplier_exportExcel(pParameter) {
  if (!pParameter) pParameter = {};
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/managerSupplier/flightSupplier/exportExcel'
  params.data = pParameter
  return new Promise(function(resolve, reject) {
    resolve(__request(params))
  })
}
